const request = {
    invalid_input: '入力が無効です。 {{details}}',
    general: 'リクエストエラーが発生しました。',
    /** UNTRANSLATED */
    range_not_satisfiable: 'Range not satisfiable.',
};
export default Object.freeze(request);
